import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';

/**
 * Create an instance of the GraphicsLayer and returns it
 * @param {Object} mapObject - map object
 * @param {Object} configs
 * @param {Object} configs.point - the coordinates to draw the marker
 * @param {Url} configs.icon - the svg icon used for the marker
 */
export const createGraphicsLayer = async ({ mapObject, configs }) =>
  await handleLayer({ configs });

const handleLayer = ({ configs }) => new GraphicsLayer(configs);
